<div class="section-wrapper">
  <div class="section-header">
    <ng-icon class="section-icon" [name]="'heroClipboard'" [size]="'24px'" [color]="'#822AC6'"
      [strokeWidth]="'2'"></ng-icon>
    <div class="section-heading">{{ 'ACCOUNT.ACCOUNT.EMAIL' | translate }}</div>
  </div>
  <div class="section-content-wrapper">
    <span class="section-content">
      <span class="section-content-label">{{ userData?.email}}</span>
      <rosie-button [customClass]="'secondary text-sm'" [translationKey]="'COMMON.LOGOUT'" class=""
        [iconPrefixConfig]="{name: 'heroArrowRightStartOnRectangle', color: '#6C6176', size: '20px', strokeWidth: '2px'}"
        (click)="logout()"></rosie-button>
    </span>
  </div>
</div>
<div class="section-wrapper">
  <div class="section-header">
    <ng-icon class="section-icon" [name]="'heroFolderOpen'" [size]="'24px'" [color]="'#822AC6'"
      [strokeWidth]="'2'"></ng-icon>
    <div class="section-heading">
      {{ 'ACCOUNT.ACCOUNT.RECORDINGS' | translate }}
    </div>
  </div>
  <div class="section-content-wrapper">
    <div class="section-content">
      <div>
        <div class="section-content-label">{{'ACCOUNT.ACCOUNT.CLEAR_RECORDINGS' | translate}}</div>
        <div class="section-content-sublabel">{{'ACCOUNT.ACCOUNT.CLEAR_RECORDINGS_DESCRIPTION' | translate}}
        </div>
      </div>
      <rosie-button [customClass]="'secondary text-sm'" [translationKey]="'ACCOUNT.ACCOUNT.CLEAR_RECORDINGS_ACTION'"
        class="" [iconPrefixConfig]="{name: 'heroTrash', color: '#6C6176', size: '20px', strokeWidth: '2px'}"
        (click)="clearRecordingModal.open()"></rosie-button>
    </div>
  </div>
</div>
<div class="section-wrapper">
  <div class="section-header">
    <ng-icon class="section-icon" [name]="'heroDevicePhoneMobile'" [size]="'24px'" [color]="'#822AC6'"
      [strokeWidth]="'2'"></ng-icon>
    <div class="section-heading">
      {{ 'ACCOUNT.ACCOUNT.VERIFICATION_CODES' | translate }}
    </div>
  </div>
  <div class="section-content-wrapper">
    <div class="d-flex align-items-md-center justify-content-between gap-2 flex-wrap">
      <div class="verification-wrapper">
        <div class="section-content-label">{{'ACCOUNT.ACCOUNT.VERIFICATION_CODES_RECEIVE' | translate}}
        </div>
        <div class="section-content-sublabel">{{'ACCOUNT.ACCOUNT.VERIFICATION_CODES_RECEIVE_DESCRIPTION' |
          translate}}
        </div>
      </div>
      <rosie-switch [ariaLabel]="'ACCOUNT.ACCOUNT.VERIFICATION_CODES_RECEIVE' | translate" [control]="verificationForm?.get('sms')" class="notification-switch"></rosie-switch>
    </div>
  </div>
  <ng-container *ngIf="verificationForm?.value?.sms">
    <div class="section-content-wrapper pt-0">
      <div class="section-content">
        <div>
          <div class="section-content-description-label">{{'ACCOUNT.ACCOUNT.VERIFICATION_CODES_HISTORY' |
            translate}}
          </div>
        </div>
        <rosie-button [customClass]="'secondary text-sm capitalize'" [translationKey]="'ACCOUNT.ACCOUNT.VIEW_TEXTS'"
          (click)="smsModal.open()"></rosie-button>
      </div>
    </div>
    <div class="separator full mt-0 mb-5"></div>
  </ng-container>
  <div class="section-content-wrapper py-0">
    <div class="d-flex align-items-md-center justify-content-between gap-2 flex-wrap">
      <div class="verification-wrapper">
        <div class="section-content-label">{{'ACCOUNT.ACCOUNT.DIALPAD_VERIFICATION' | translate}}
        </div>
        <div class="section-content-sublabel">{{'ACCOUNT.ACCOUNT.DIALPAD_VERIFICATION_DESCRIPTION' |
          translate}}
        </div>
      </div>
      <rosie-switch [ariaLabel]="'ACCOUNT.ACCOUNT.DIALPAD_VERIFICATION' | translate" [control]="verificationForm?.get('dialpadVerification')" class="notification-switch"></rosie-switch>
    </div>
  </div>
  <div class="section-content-wrapper">
    <div class="d-flex align-items-md-center justify-content-between gap-2 flex-wrap">
      <div class="verification-wrapper">
        <div class="section-content-label">{{'ACCOUNT.ACCOUNT.GOOGLE_VERIFICATION' | translate}}
        </div>
        <div class="section-content-sublabel">{{'ACCOUNT.ACCOUNT.GOOGLE_VERIFICATION_DESCRIPTION' |
          translate}}
        </div>
      </div>
      <rosie-switch [ariaLabel]="'ACCOUNT.ACCOUNT.GOOGLE_VERIFICATION' | translate" [control]="verificationForm?.get('gbpVerification')" class="notification-switch"></rosie-switch>
    </div>
  </div>
</div>
<div class="section-wrapper sms-compliance-section" *ngIf="hasSmsComplianceSupport">
  <div class="section-header">
    <ng-icon class="section-icon" [name]="'heroShieldCheck'" [size]="'24px'" [color]="'#822AC6'"
      [strokeWidth]="'2'"></ng-icon>
    <div class="section-heading">
      {{ 'ACCOUNT.ACCOUNT.SMS_COMPLIANCE' | translate }}
    </div>
  </div>
  <div class="section-content-wrapper">
    <div class="section-content">
      <span class="section-content-label d-flex align-items-center">Double Opt-In Verification
        <div class="setup-item-value d-flex align-items-center call-notifications-preview-item ml-5">
          <span class="setup-item-tag"
            [ngClass]="{'on': isOptInVerificationEnabled, 'disabled': !isOptInVerificationEnabled}"><ng-icon
              [name]="'heroCheckBadgeSolid'" [size]="'12px'"
              [color]="!isOptInVerificationEnabled ? '#6C6176' : '#047857'"></ng-icon>
            {{isOptInVerificationEnabled ? 'ON' : 'OFF'}}</span>
        </div>
      </span>
      <rosie-button [customClass]="'secondary text-sm'" [translationKey]="'COMMON.EDIT'"
        [iconPrefixConfig]="{name: 'heroPencilSquare', size: '20px', strokeWidth: '2', color: '#6C6176'}"
        (click)="smsComplianceModal.open()"></rosie-button>
    </div>
  </div>
</div>
<ngx-smart-modal #clearRecordingModal disableRefocus identifier="clearRecordingModal">
  <div class="modal-title with-subtitle">
    {{'ACCOUNT.ACCOUNT.CLEAR_ALL_RECORDINGS' | translate}}
  </div>
  <div class="modal-subtitle with-border"></div>
  <div class="modal-content" [innerHTML]="'ACCOUNT.ACCOUNT.CLEAR_RECORDINGS_DELETION' | translate">
  </div>
  <div class="modal-action-line with-border">
    <rosie-button (click)="clearRecordingModal.close()" [translationKey]="'COMMON.CANCEL'"
      [customClass]="'secondary d-block'">
    </rosie-button>
    <rosie-button (click)="clearRecordingData()" [customClass]="'danger d-block slim'"
      [inProgress]="isClearRecordingsInProgress" [translationKey]="'COMMON.DELETE'">
    </rosie-button>
  </div>
</ngx-smart-modal>
<ngx-smart-modal #smsModal disableRefocus identifier="smsModal" (onOpen)="fetchSmsList()">
  <div class="modal-title with-subtitle">
    {{'ACCOUNT.ACCOUNT.VIEW_TEXTS' | translate}}
  </div>
  <div class="modal-subtitle with-border">
    {{'ACCOUNT.ACCOUNT.VIEW_TEXTS_DESCRIPTION' | translate}}
    <span (click)="fetchSmsList()" class="text-underline pointer refresh-messages">{{'ACCOUNT.ACCOUNT.REFRESH_MESSAGES'
      |
      translate}}</span>
  </div>
  <div class="modal-content">
    <div class="modal-description mb-0">
      <div *ngFor="let sms of smsList; let first = first;" class="message" [ngClass]="{'first': first}">
        <div class="text">{{sms}}</div>
      </div>
    </div>
  </div>
</ngx-smart-modal>
<ngx-smart-modal #smsComplianceModal disableRefocus identifier="smsComplianceModal" [customClass]="'compliance-modal'">
  <div class="modal-title with-subtitle">
    {{'ACCOUNT.ACCOUNT.SMS_COMPLIANCE_MODAL_TITLE' | translate}}
  </div>
  <div class="modal-subtitle with-border">
  </div>
  <div class="modal-content">
    <div class="sms-compliance-wrapper">
      <div class="sms-compliance-settings">
        <div class="label">SMS Compliance</div>
        <div class="description">You can disable the double opt-in verification at any time — just know you assume any
          legal risk in doing so.</div>
        <div class="d-flex align-items-start sms-compliance-switch-wrapper">
          <rosie-switch [ariaLabel]="'Double Opt-In Verification'" [control]="optInVerificationEnabled" class="d-flex"></rosie-switch>
          <div>
            <div class="label">Double Opt-In Verification</div>
            <div class="description mb-md">
              Send an initial text to allow the user to opt-in to receiving texts
            </div>
          </div>
        </div>
      </div>
      <div class="sms-compliance-preview">
        <div class="d-flex gap-2 align-items-center heading-section">
          <ng-icon class="icon" [name]="'heroEyeSolid'" [size]="'16px'" [color]="'#822AC6'"></ng-icon>
          <div class="preview-title">Preview of Initial Opt-In Text</div>
        </div>
        <div class="preview-text">
          {{optInTextPreview}}
        </div>
      </div>
    </div>
  </div>
  <div class="modal-action-line with-border">
    <rosie-button (click)="smsComplianceModal.close()" class="d-block" [customClass]="'secondary narrow'"
      [translationKey]="'COMMON.CANCEL'">
    </rosie-button>
    <rosie-button (click)="saveSmsComplianceChanges()" class="d-block" [customClass]="'narrow slim'"
      [translationKey]="'COMMON.SAVE'">
    </rosie-button>
  </div>
</ngx-smart-modal>